<ng-container [appLazyLoader]="lazyModuleConfig"></ng-container>
